import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import {
  Tooltip,
  Modal,
  Form,
  Radio,
  Button,
  Select,
  Spin,
  AutoComplete,
  Input,
  DatePicker,
  Icon,
  message,
  Checkbox
} from 'antd'
import { actions } from '../../redux/modules/dashboard/dashboardActions'
import { actions as auditActions } from '../../redux/modules/auditActions'
import { actions as userActions } from '../../redux/modules/userActions'
import { convertNamesToOption, convertToOption, filterCaseInsensitive } from '../../util'
import { getShortcut } from '../../util/dashboardFollowUps'
import _ from 'lodash'
import moment from 'moment'
import config from '../../config'
const { API_BASE } = config

const FormItem = Form.Item
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const Option = Select.Option
const { TextArea } = Input

const propTypes = {}

class FollowUpsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      activeKey: '1',
      show30d: true
    }

    // define user id to get follow ups
    const userId = this.getUserId()

    this.props.getDashboardFollowUps({
      userId: userId,
      show30d: this.state.show30d
    })

    this.props.getUsers()
    this.props.getUserRoles()
  }

  getUserId = () => {
    let userId = 0
    if (this.props.authentication.user.isAdmin) {
      userId = this.props.selectedUser ? this.props.selectedUser : 0
    } else {
      userId = this.props.authentication.user.userId
    }

    return userId
  }

  componentDidUpdate(prevProps) {
    const { selectedUser } = this.props
    if (selectedUser !== prevProps.selectedUser) {
      this.props.getDashboardFollowUps({
        userId: selectedUser,
        show30d: this.state.show30d
      })
    }
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleUpdate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      values.due_date = moment(values.due_date)
        .endOf('day')
        .format('YYYY-MM-DD hh:mm:ss')
      this.props.updateDashboardFollowUp({
        leadId: this.props.leadId,
        followUpId: this.state.currentId,
        content: values,
        userId: this.props.authentication.user.userId
      })

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  handleShortcutData = row => {
    const followUpShortcuts = getShortcut(row)

    this.setState({
      shortcutId: followUpShortcuts.shortcutId,
      relatedId: followUpShortcuts.relatedId,
      shortcutTargetPage: followUpShortcuts.shortcutTargetPage
    })
  }

  handleRowClick = row => {
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'follow_up'
    })
    this.handleShortcutData(row)
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row,
      activeKey: '1',
      assignToType: row.assigned_to_id ? 'user' : 'role'
    })
  }

  handleChangeAssignedToType = e => {
    this.setState({
      assignToType: e.target.value
    })
  }
  handleRevisionChange = value => {
    const form = this.props.form
    const revisions = JSON.parse(
      this.props.auditActions.revisions.data.find(x => x.id === value).json_patch
    )

    const foundIsUser = revisions.find(revision => revision.path === '/assigned_to_id')

    const isUser = foundIsUser && Boolean(+foundIsUser.value)

    this.setState(
      {
        assignToType: isUser ? 'user' : 'role'
      },
      () => {
        let changes = {}
        revisions.forEach(revision => {
          const fieldName = revision.path.substring(1, revision.path.length)
          const isAssignedToField =
            fieldName === 'assigned_to_id' || fieldName === 'assigned_to_role_id'
          if (!_.isNil(form.getFieldsValue()[fieldName]) || isAssignedToField) {
            if (!_.isNil(revision.value)) {
              changes[fieldName] = revision.value.toString()
            }
          }
        })
        if (changes.due_date) changes.due_date = moment(changes.due_date)

        form.setFieldsValue(changes)
      }
    )
  }

  changeUpTo30d = e => {
    this.props.getDashboardFollowUps({
      userId: this.getUserId(),
      show30d: e.target.checked
    })

    this.setState({
      show30d: e.target.checked
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { contentData } = this.state

    const followUps = _.get(this.props, 'dashboardActions.dashboardFollowUps.data')
    const revisions = _.get(this.props, 'auditActions.revisions.data')
    const loadingRevision = this.props.auditActions && this.props.auditActions.loading
    return (
      <div>
        <div className="jobsBar">
          Follow Ups
          <div>
            <Checkbox
              checked={this.state.show30d}
              onChange={this.changeUpTo30d}
              style={{ color: 'white', marginRight: 20 }}
            >
              Show Up 30 days
            </Checkbox>
            <a
              href={`${API_BASE}/api/dashboard/follow-ups/${this.getUserId()}/print`}
              target="_blank"
            >
              <Button shape="circle" icon="printer" style={{ marginTop: -4 }} />
            </a>
          </div>
        </div>
        <div>
          <Modal
            visible={this.state.modalVisible}
            title="Follow Ups"
            okText="Save Changes"
            onCancel={this.handleCancel}
            onOk={this.handleUpdate}
            width={'80%'}
            maskClosable={false}
          >
            <Form layout="vertical">
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Status">
                    {getFieldDecorator('status', {
                      initialValue: contentData ? contentData.status : ''
                    })(
                      <RadioGroup>
                        <RadioButton value="Unopened">Unopened</RadioButton>
                        <RadioButton value="Opened">Opened</RadioButton>
                        <RadioButton value="Closed">Closed</RadioButton>
                        <RadioButton value="OVERDUE">OVERDUE</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                {contentData && (
                  <div className="col-md-3">
                    <FormItem label="Shortcut">
                      {this.state.shortcutTargetPage && (
                        <Link to={this.state.shortcutTargetPage}>
                          <Button icon="link">
                            {' '}
                            {this.state.relatedId ? this.state.relatedId : this.state.shortcutId}
                          </Button>
                        </Link>
                      )}
                      {!this.state.shortcutTargetPage && 'N/A'}
                    </FormItem>
                  </div>
                )}
                <div className="col-md-3">
                  <FormItem label="Revision">
                    {getFieldDecorator('revision', {
                      initialValue:
                        revisions && revisions.length > 0
                          ? revisions[revisions.length - 1].id
                          : null
                    })(
                      loadingRevision ? (
                        <Spin size="small" />
                      ) : (
                        <Select onChange={this.handleRevisionChange}>
                          {revisions &&
                            revisions.map(revision => (
                              <Option key={revision.id} value={revision.id}>
                                {revision.revision}
                              </Option>
                            ))}
                        </Select>
                      )
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <FormItem label="Type">
                    {getFieldDecorator('type', {
                      rules: [
                        {
                          required: true,
                          message: 'There must be a type'
                        }
                      ],
                      initialValue: contentData ? contentData.type : ''
                    })(<Input disabled={contentData ? true : false} />)}
                  </FormItem>
                </div>
                <div className="col-3">
                  <FormItem label="Due Date">
                    {getFieldDecorator('due_date', {
                      rules: [
                        {
                          required: true,
                          message: 'You must choose a due date'
                        }
                      ],
                      initialValue: contentData ? moment(contentData.due_date) : null
                    })(<DatePicker format="MM/DD/YYYY" placeholder="Select Time" />)}
                  </FormItem>
                </div>
                <div className="col-3">
                  <FormItem label="Assigned To Type">
                    {getFieldDecorator('assigned_to_type', {
                      initialValue: this.state.assignToType
                    })(
                      <RadioGroup onChange={this.handleChangeAssignedToType}>
                        <RadioButton value="user">User</RadioButton>
                        <RadioButton value="role">Role</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                <div className="col-3">
                  {this.state.assignToType === 'user' && (
                    <FormItem label="Assign To User">
                      {getFieldDecorator('assigned_to_id', {
                        rules: [
                          {
                            required: this.state.assignToType === 'user' ? false : true,
                            message: 'You must assign this to someone'
                          }
                        ],
                        initialValue:
                          contentData && contentData.assigned_to_id
                            ? contentData.assigned_to_id.toString()
                            : ''
                      })(
                        <AutoComplete
                          dataSource={convertNamesToOption(
                            this.props.userActions &&
                              this.props.userActions.users &&
                              this.props.userActions.users.data
                          )}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  )}
                  {this.state.assignToType === 'role' && (
                    <FormItem label="Assign To Role">
                      {getFieldDecorator('assigned_to_role_id', {
                        rules: [
                          {
                            required: this.state.assignToType === 'role' ? false : true,
                            message: 'You must assign this to someone'
                          }
                        ],
                        initialValue:
                          contentData && contentData.assigned_to_role_id
                            ? contentData.assigned_to_role_id.toString()
                            : ''
                      })(
                        <AutoComplete
                          dataSource={convertToOption(
                            this.props.userActions &&
                              this.props.userActions.roles &&
                              this.props.userActions.roles.data
                          )}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Description">
                    {getFieldDecorator('description', {
                      initialValue: contentData ? contentData.description : ''
                    })(<TextArea placeholder="Type in your note..." rows={4} />)}
                  </FormItem>
                </div>
              </div>
            </Form>
          </Modal>
          {followUps && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTdProps={(state, rowInfo, column, instance) => ({
                onClick: e => {
                  if (column.Header !== undefined) {
                    this.handleRowClick(rowInfo.original)
                  }
                }
              })}
              data={followUps}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Target Name',
                      id: 'target_name',
                      accessor: d => (d.job_id ? d.job_name : d.lead_name),
                      Cell: d => {
                        const type = d.original.job_id ? 'Job' : 'Lead'
                        let link = ''
                        if (type === 'Job') {
                          const jobType = d.original.job_type.replace('/', '-') // workaround to remove slash on job type route
                          link = `/jobView/${d.original.job_id}/${jobType}`
                        } else {
                          link = `/lead/${d.original.lead_id}`
                        }
                        return (
                          <Tooltip
                            title={
                              d.original.job_name
                                ? `${d.original.job_name} - ${type}`
                                : `${d.original.lead_name} - ${type}`
                            }
                          >
                            <Link to={link}>
                              {d.original.job_name
                                ? `${d.original.job_name} - ${type}`
                                : `${d.original.lead_name} - ${type}`}
                            </Link>
                          </Tooltip>
                        )
                      },
                      maxWidth: 300,
                      filterMethod: (filter, row) => {
                        const value = filter.value.toUpperCase()
                        if (row._original.job_id) {
                          return (
                            _.isString(row._original.job_name) &&
                            row._original.job_name.toUpperCase().includes(value)
                          )
                        } else {
                          return (
                            _.isString(row._original.lead_name) &&
                            row._original.lead_name.toUpperCase().includes(value)
                          )
                        }
                      }
                    },
                    {
                      Header: 'Type',
                      id: 'type',
                      accessor: 'type',
                      Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>,
                      maxWidth: 300
                    },
                    {
                      Header: 'Due date',
                      id: 'due_date',
                      accessor: d => moment(d.due_date).format('M/D/YYYY'),
                      maxWidth: 110
                    },
                    {
                      Header: 'Assigned To',
                      id: 'assigned_to_name',
                      accessor: d =>
                        d.assigned_to_role_name
                          ? d.assigned_to_role_name
                          : `${d.assigned_to_first_name} ${d.assigned_to_last_name}`,
                      Cell: d => {
                        let r = ''
                        if (d.original.assigned_to_role_name) {
                          r = d.original.assigned_to_role_name
                        } else {
                          r = `${d.original.assigned_to_first_name} ${
                            d.original.assigned_to_last_name
                          }`
                        }
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      maxWidth: 110
                    },
                    {
                      Header: 'Description',
                      id: 'description',
                      accessor: 'description',
                      Cell: d => (
                        <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                      )
                    },
                    {
                      Header: 'Related ID',
                      id: 'related_id',
                      accessor: d => {
                        const followUpShortcuts = getShortcut(d)
                        return followUpShortcuts.shortcutId
                      },
                      Cell: d => {
                        const followUpShortcuts = getShortcut(d.original)
                        if (followUpShortcuts.shortcutTargetPage) {
                          return (
                            <Tooltip title={followUpShortcuts.shortcutId}>
                              <Link to={followUpShortcuts.shortcutTargetPage}>
                                {followUpShortcuts.shortcutId}
                              </Link>
                            </Tooltip>
                          )
                        } else {
                          return 'N/A'
                        }
                      },
                      maxWidth: 100
                    },
                    {
                      Header: 'Status',
                      accessor: 'status',
                      Cell: row => {
                        let color = null
                        if (row.value === 'OVERDUE') {
                          color = '#ff2e00'
                        } else {
                          if (row.value === 'Opened') {
                            color = '#ffbf00'
                          } else {
                            color = '#57d500'
                          }
                        }
                        return (
                          <span>
                            <span
                              style={{
                                color: color,
                                transition: 'all .3s ease'
                              }}
                            >
                              &#x25cf;
                            </span>
                            {row.value}
                          </span>
                        )
                      },
                      maxWidth: 100
                    }
                  ]
                }
              ]}
              defaultSorted={[
                {
                  id: 'id',
                  desc: true
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (
  { dashboardActions, authentication, auditActions, userActions },
  ownProps
) => ({
  dashboardActions,
  authentication,
  auditActions,
  userActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, auditActions, userActions), dispatch)
})

FollowUpsContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(FollowUpsContainer))
)



// WEBPACK FOOTER //
// ./src/containers/dashboard/FollowUpsContainer.js